import * as types from "./viewConciergeTypes";

export const fetchConciergesRequest = () => ({
    type: types.FETCH_CONCIERGE_REQUEST,
  });
  
  export const fetchConciergesSuccess = (concierges) => ({
    type: types.FETCH_CONCIERGE_SUCCESS,
    payload: concierges,
  });
  
  export const fetchConciergesFailure = (error) => ({
    type: types.FETCH_CONCIERGE_FAILURE,
    payload: error,
  });